import {verifiedFetchJSON, type JSONRequestInit} from '@github-ui/verified-fetch'
import {buildItemPickersBulkActionsUrl} from '@github-ui/item-picker-base/api/urls'
import type {GraphQLResponse} from '@github-ui/item-picker-base/api/graphql'

export type UpdateIssueAssigneesBulkRequest = {
  ids: string[]
  applyAssigneeIds?: string[]
  removeAssigneeIds?: string[]
}

type UpdateIssueAssigneesBulkResponseData = {
  updateIssuesBulk: {
    jobId: string
  }
}

export type UpdateIssueAssigneesBulkResponse = GraphQLResponse<UpdateIssueAssigneesBulkResponseData>

export async function apiUpdateIssueAssigneesBulk(
  request: UpdateIssueAssigneesBulkRequest,
): Promise<UpdateIssueAssigneesBulkResponse> {
  const requestUrl = buildItemPickersBulkActionsUrl()
  const body: Record<string, unknown> = {ids: request.ids}

  if (request.applyAssigneeIds && request.applyAssigneeIds.length > 0) {
    body['applyAssigneeIds'] = request.applyAssigneeIds
  }

  if (request.removeAssigneeIds && request.removeAssigneeIds.length > 0) {
    body['removeAssigneeIds'] = request.removeAssigneeIds
  }

  const init: JSONRequestInit = {
    method: 'POST',
    body,
  }
  const response = await verifiedFetchJSON(requestUrl, init)
  return response.json() as Promise<UpdateIssueAssigneesBulkResponse>
}
